// extracted by mini-css-extract-plugin
export default {"main":"ica-z"};